export function resolveData(response) {
   return Promise.resolve(response.data || null);
}
